// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"ShowPartners_animate-height__2sSvP","TableScroll":"ShowPartners_TableScroll__hoNCN","animateHeight":"ShowPartners_animateHeight__29sIl"};